<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-analysis/modelList' }">模型管理</el-breadcrumb-item>
            <el-breadcrumb-item><a @click.prevent="goBack">模型配置</a></el-breadcrumb-item>
            <el-breadcrumb-item>干预配置</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <el-form ref="myForm" :model="formData" :rules="formRules" :label-width="formLabelWidth">
          <el-form-item :label="'主体（' + areaTypeName + '）:'" prop="area_id">
            <el-select
              v-model="formData.area_id"
              style="width: 15%"
              filterable
              clearable
              disabled
              @change="areaSelectChange"
            >
              <el-option
                v-for="item in areaData"
                :key="item.id"
                :label="item.area_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模型总分:">
            <span>{{scoreTotal}}</span>
            <!-- <el-input type="number" v-model="pattern_score_overwrite" style="width: 15%" placeholder="0~100整数"></el-input> -->
          </el-form-item>
          <el-form-item label="模型总分干预:">
            <el-input type="number" v-model="pattern_score_overwrite" style="width: 15%" placeholder="0~100整数"></el-input>
          </el-form-item>
          
          <div class="zv-flex-wrap">
            <div class="zv-form-item-label">风险模块干预:</div>
            <div class="zv-form-item-content" style="display: block; max-width: 1205px;">
              <el-table
                :data="modelMainItems"
                style="width: 100%"
                class="my-expand-table"
              >
                <el-table-column label="风险模块名称" :align="tableAlign" prop="pattern_item_name" >
                </el-table-column>
                <el-table-column label="模块风险类型" :align="tableAlign" prop="risk_name">
                </el-table-column>
                <el-table-column label="模块编号" :align="tableAlign" prop="first_no">
                </el-table-column>
                <el-table-column label="模块分数" :align="tableAlign" prop="score">
                </el-table-column>
                <el-table-column label="干预分数" :align="tableAlign">
                  <template slot-scope="scope">
                    <el-input type="number" v-model="scope.row.pattern_item_score_overwrite" placeholder="0~100整数"></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <el-form-item label-width="auto" class="fi-flex-center paddint-t-30">
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="doSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import api from './api';
import formPageMixin from "@/mixins/formPageMixin";
import addFormMixin from "@/mixins/addFormMixin";
import TipUtil from "@/utils/utils/TipUtil";
import _ from "lodash";

export default {
  name: "CreateModelMain",
  mixins: [formPageMixin, addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      pattern_score_overwrite: '', // lafitewu => 4.22 新增模型总分干预
      pattern_id: '', // 模型id
      area_id: '', // 地区id
      area_type: '', // 模型类型
      isEdit: false,   // 是否为编辑
      areaData: [],  // 地区数据
      modelMainInfo: {} , // 模型主体详情
      modelMainItems: [] , // 模型主体
      formData: {
        area_id: '',  // 主体（国家）id
      },
      formRules: {
        area_id: {
          required: true,
          message: "主体不能为空",
          trigger: "change"
        }
      },
      riskModelWeightArr: [],  // 风险模块权重值数组
      riskModelFieldWeightArr: [], // 模块参考因素项目的权重
      tableOri: {

      },
      subTables: [],     // 子表格数据
      // subTables: [{   // 子表格数据
      //   table1: [],
      //   table2: [],
      //   table3: [],
      //   table4: []
      // }],

      // 弹出的三个table数据
      dialogTablesData: [],
      // 弹出框表格数据数组
      dialogCurTable: {
        curId: '',
        modelIndex: 0,
        data: []
      },
      // 影响性下拉数据
      areaTypeForEventList: vm.$enums.AreaType.forEventList,
      // 特殊加权下拉选项数据
      areaRiskTypeList: [],
      scoreTotal: ''
    };
  },
  computed: {
    areaTypeName() {
      return this.$enums.AreaType.getForModeName(this.area_type)
    }
  },

  methods: {
    initCommonData() {
      this.formData.area_id = this.area_id
      this.$commFunc.getAreaList({area_type: this.area_type}).then(res => {
        this.areaData = res
      })
      this.getAreaCommonData()
    },

    areaSelectChange(area_id) {
      this.area_id = area_id;
      this.getAreaCommonData();
    },

    getAreaCommonData() {
      this.getModelMainInfo()
    },

    // 获取模块详情
    async getModelMainInfo() {
      if (this.area_id && this.pattern_id) {
        // 获取模型主体详情信息
        let res = await api.modelMainDetail({
          pattern_id: this.pattern_id,
          area_id: this.area_id
        })

        this.modelMainInfo = res.info
        let riskModelWeightArrTemp = []
        let subTableArr = []
        let dialogTableArr = []
        res.info.pattern_item.forEach((item, modelIndex) => {
          item.first_no = `M${item.id}`
          item.second_no = `Pm${item.id}`
          let isNew = item.area_weight_config ? true : false
          riskModelWeightArrTemp.push({
            id: item.id,
            value: isNew ? item.area_weight_config.pattern_item_weight : ''
          })

        })
        this.scoreTotal = res.info.score
        this.modelMainItems = res.info.pattern_item
        this.pattern_score_overwrite = res.info.pattern_score_overwrite
      }
    },

    doSubmit() {
      this.$refs.myForm.validate(async valid => {
        if (!valid) {
          TipUtil.message('请检查表单!', 'warning')
          return
        }
        let turn;
        // 判断是否为整数
        this.modelMainItems.map(item => {
          if(!this.isInteger(Number(item.pattern_item_score_overwrite))) {
            TipUtil.message('请检查表单!', 'warning')
            return turn = 1
          }
        })
        if(turn != 1) {
          let processObj = this.processSubmitData()
          let res = await api.addModelIntervene(processObj)
          let msg = '干预配置成功'
          TipUtil.message(msg, "success")
          setTimeout(() => {
            this.goBack()
          }, 200)
        }
      })
    },
    isInteger(obj){
      return Math.round(obj) === obj   //是整数，则返回true，否则返回false
    },
    processSubmitData() {
      let processObj = {
        area_id: this.area_id,
        pattern_id: this.pattern_id,
        pattern_score: this.pattern_score_overwrite,
        pattern_item_id: this.modelMainItems.map(item => item.id).join(','),
        pattern_item_score: this.modelMainItems.map(item => item.pattern_item_score_overwrite).join(','),
      }

      return processObj
    },
    goBack() {
      this.$router.push({path: '/data-analysis/configModel',query: {id: this.$route.query.pattern_id}})
    }
  },

  created() {
    let pattern_id = this.$route.query.pattern_id
    if (pattern_id) {
      this.pattern_id = parseInt(pattern_id)
    }
    let area_type = this.$route.query.area_type
    if (area_type) {
      this.area_type = area_type
    }

    let area_id = this.$route.query.area_id
    if (area_id) {
      this.area_id = parseInt(area_id)
      this.isEdit = true
    }

    this.initCommonData();
  },
  mounted() {
  },
  beforeDestroy() {

  },
};
</script>

<style lang="less">
  .config-model-table-title {
    margin-top: 15px;
    padding: 15px 20px;
    background: #f6f6f6;
    text-align: center;
    border-bottom: 1px solid #ddd;
    border-top: 1px solid #ddd;
    font-size: 14px;
    font-weight: bold;
    &.style-mt-0 {
      margin-top: 0;
    }
  }
  .config-model-main-tips {
    font-size: 12px;
    color: #999;
    padding-top: 5px;
  }
</style>
